import { CardContent } from '@mui/material'
import SubCard from 'src/components/material/Cards/SubCard'
import CycleReportTable from 'src/components/material/DeviceDashboard/CycleReport/CycleReportTable'
import ReportTypeToggle from 'src/components/material/DeviceDashboard/CycleReport/ReportTypeToggle'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { fetchCycleEvents, fetchCustomerCycles, setComplianceReport, setSelectedCycle, selectCyclesByFacilities } from '../summaryDashboardSlice'

const CycleReportContainer = () => {

    const { t } = useTranslation("translations");
    const {
        deviceFacilityAddress,
        customerName,
        deviceSerial,
        weightUnit,
        selectedCycle,
        biochallengeInfo,
        currentPressureUnit,
        complianceReport,
        deviceTimezone,
        userTimezone,
        fromDate,
        toDate,
        deviceConfigId,
        selectedFacilities
    } = useSelector(
        // @ts-ignore
        (store) => store.summarydashboard
    );

    const filteredCycles = useSelector((store) => selectCyclesByFacilities(store.summarydashboard, selectedFacilities.map(facility => facility.name)));

    const loading = useSelector((store) => store.summarydashboard.loading.cycleReport);

    const dispatch = useDispatch();

    const cycleSelectionHandler = (cycle) => {
        dispatch(setSelectedCycle(cycle.row));
    };

    const fetchCycles = () => {
        dispatch(fetchCustomerCycles());
    };

    const setReportType = (/** @type {boolean} */ isCompliance) => {
        dispatch(setComplianceReport(isCompliance));
    };


    return (
        <SubCard
            sx={{ width: "100%" }}
            title={t("Cycle Report")}
            titleProps={{ color: "primary", fontWeight: "bold" }}
            titleVariant={"h4"}
            secondary={<ReportTypeToggle deviceConfigId={deviceConfigId} setComplianceReport={setReportType} fetchCycles={fetchCycles} />}>
            <CardContent sx={{ padding: 0 }}>
                <CycleReportTable
                    deviceCycles={filteredCycles || []}
                    deviceFacilityAddress={deviceFacilityAddress}
                    customerName={customerName}
                    deviceSerial={deviceSerial}
                    weightUnit={weightUnit}
                    selectedCycle={selectedCycle}
                    biochallengeInfo={biochallengeInfo}
                    currentPressureUnit={currentPressureUnit}
                    complianceReport={complianceReport}
                    deviceTimezone={deviceTimezone}
                    userTimezone={userTimezone}
                    fromDate={fromDate}
                    toDate={toDate}
                    loading={loading}
                    isSummary={true}
                    cycleSelectionHandler={cycleSelectionHandler}
                />
            </CardContent>
        </SubCard>
    )
}

export default CycleReportContainer
